<template>
  <div class="values-master-detail">
    <master-detail :items="$options.valueItems" />
  </div>
</template>

<script>
import MasterDetail from '@/components/master-detail/MasterDetail';

const valueItems = [
  {
    id: 'integrity',
    title: 'Integrity',
    iconFilename: 'integrity-icon.png',
    imageSubtext: 'Do the right thing, always.',
    imageFilename: 'Integrity.gif'
  },
  {
    id: 'diversity',
    title: 'Diversity',
    iconFilename: 'diversity-icon.png',
    imageSubtext: 'Intentionally commit to the equitable respect, inclusion, and empowerment of all individuals.',
    imageFilename: 'Diversity.gif'
  },
  {
    id: 'responsiveness',
    title: 'Responsiveness',
    iconFilename: 'responsiveness-icon.png',
    imageSubtext: 'Act promptly and decisively, anchored by deep knowledge and careful listening.',
    imageFilename: 'Responsiveness.gif'
  },
  {
    id: 'collaboration',
    title: 'Collaboration',
    iconFilename: 'collaboration-icon.png',
    imageSubtext: 'Work enthusiastically with others and be open to different perspectives.',
    imageFilename: 'Collaboration.gif'
  },
  {
    id: 'service',
    title: 'Service',
    iconFilename: 'service-icon.png',
    imageSubtext: 'Commit to helping our policyholders, team members, and community.',
    imageFilename: 'Service.gif'
  },
  {
    id: 'innovation',
    title: 'Innovation',
    iconFilename: 'innovation-icon.png',
    imageSubtext: 'Continually seek better solutions while anticipating future needs.',
    imageFilename: 'Innovation.gif'
  },
  {
    id: 'stewardship',
    title: 'Stewardship',
    iconFilename: 'stewardship-icon.png',
    imageSubtext: 'Take good care of the resources entrusted to us.',
    imageFilename: 'Stewardship.gif'
  }
];

export default {
  name: 'ValuesMasterDetail',
  components: {
    MasterDetail
  },
  valueItems
};
</script>
